﻿import {IProjetModel} from "../../Model/Projet/ProjetModel.js";
import {KendoToolBarHandler} from "../../Tools/Misc.js";
import {ProjetUpsert} from "../../Controller/Projet/ProjetUpsert.js";
import {ProjetDeleteController} from "../../Controller/Projet/ProjetDelete";
import {NotificationHelper} from "../../Helper/NotificationHelper";

export class ProjetEditor {
    #isValid: boolean = false;
    #jqContainer: JQuery | undefined;
    #jqFormContainer: JQuery | undefined;
    #jqMainContainer: JQuery | undefined;
    #jqTool: JQuery | undefined;
    #kForm: kendo.ui.Form | undefined;
    #model?: IProjetModel | undefined;
    #projetId: string | undefined;

    constructor(options: IProjetEditorOption) {

        this.#projetId = options.projetId;
        this.#jqMainContainer = options.jqMainContainer;
        this.#model = options.model;

    }

    public Init = () => {
        this.#buildHtml();
        this.#buildTool();
        this.#buildForm();
    }

    #buildForm = () => {
        this.#kForm = this.#jqFormContainer.kendoForm({
            formData: this.#model,
            orientation: "horizontal",
            size: "small",
            items: [
                {field: "Nom", label: "Nom", validation: {required: true}},
                {
                    field: "Primarykey", label: "Id",
                    attributes: {"circ-id": "projetId"},
                    editorOptions: {
                        enable: true,
                        suffixOptions: {icon: "copy"}
                    }, validation: {required: false}
                },
                {
                    field: "Libelle", label: "Libelle",
                    validation: {required: false},
                    editor: "TextArea",
                    editorOptions: {
                        size: "small",
                        rows: 5,
                        length: 800
                    }
                },
            ],
            change: (e: kendo.ui.FormChangeEvent) => {
                this.#model[e.field] = e.value;
            },
            validate: (e: kendo.ui.FormValidateEvent) => {
                this.#isValid = e.valid;
            }
        }).data("kendoForm");
        
        const input = this.#kForm.element.find("[circ-id='projetId']");
        input.prop("disabled", true);
        input.siblings(".k-input-suffix").on("click", (e) => {
            navigator.clipboard.writeText(input.val().toString())
                .then(() => NotificationHelper.Instance.success("L'Id a été copié dans le presse-papier"));
        });

        this.#formRemoveButton().then();


    }

    #buildHtml = () => {
        this.#jqContainer = $("<div></div>")
            .css({
                height: "100%",
                width: "100%",
                margin: 0,
                padding: 0,
                display: "flex",
                flexDirection: "column"
            }).appendTo(this.#jqMainContainer);

        this.#jqFormContainer = $("<div></div>")
            .css({
                display: "flex",
                flexDirection: "column",
                width: "50%",
                flexGrow: "1"
            }).appendTo(this.#jqContainer);

        const div = $("<div></div>")
            .css({
                width: "100%",
            }).appendTo(this.#jqContainer);

        this.#jqTool = $("<div></div>")
            .appendTo(div);
    }

    #buildTool = () => {
        this.#jqTool.kendoToolBar({
            size: "small",
            items: [
                {
                    type: "button",
                    text: "Enregistrer",
                    icon: "save",
                    click: async (e: any) => KendoToolBarHandler.AsyncToolbarHandle(e.target, this.#saveClient),
                    themeColor: "success"
                },
                {
                    type: "button",
                    text: "Supprimer",
                    icon: "trash",
                    themeColor: "error",
                    click: async (e: any) => this.#deleteProjet(),
                }
            ]
        });
    }

    #saveClient = async () => {
        this.#kForm.validate();
        if (!this.#isValid)
            return;

        return ProjetUpsert.Upsert(this.#model);
    }

    #deleteProjet = async () => {
        kendo.confirm("Bien certain de vouloir supprimer ce projet ? </br>Les templates et les objets attenants seront détruits.")
            .then(async (result) => {
                ProjetDeleteController.Delete(this.#model).then();
            });
    }

    #formRemoveButton = async () => {
        this.#kForm.element.find(".k-form-buttons").remove();
    }

    public Dispose = () => {
        this.#kForm.destroy()
        this.#jqMainContainer.empty();
    }
}

export interface IProjetEditorOption {
    jqMainContainer: JQuery;
    projetId?: string;
    model: IProjetModel;
}
